export const IMG_WIDTH = 861;
